// Mirrors `_resolve_proxy_url` in the Python note-derived-fields client. Keep
// both implementations aligned so optimistic stubs key against the same URL
// used to compute `resolve_note_attachment_uuid`.

export const resolveProxyUrl = (url: string): string => {
  const parsed = new URL(url);
  const path = parsed.pathname;

  const isProxyUrl =
    path.includes("/api/v2/assets/proxy") ||
    path.includes("assets/proxy") ||
    path === "/proxy" ||
    path.endsWith("/proxy") ||
    (parsed.protocol === "mem-storage:" && parsed.host === "proxy");

  if (!isProxyUrl) return url;

  const inner = parsed.searchParams.get("url");
  if (!inner) {
    throw new Error(`Proxy URL missing 'url' parameter: ${url}`);
  }
  return inner;
};

export const isProcessableAttachmentUrl = (url: string): boolean => {
  let resolved: string;
  try {
    resolved = resolveProxyUrl(url);
  } catch {
    return false;
  }

  let parsed: URL;
  try {
    parsed = new URL(resolved);
  } catch {
    return false;
  }

  return (
    parsed.host === "storage.googleapis.com" || parsed.host.endsWith(".storage.googleapis.com")
  );
};
